import { connect } from 'react-redux'
import { getNotes as getNotesSelector } from 'selectors/feature/notes'

import Notes from './Notes'

const mapStateToProps = (state) => ({
  notes: getNotesSelector(state),
})

const NotesContainer = connect(mapStateToProps)(Notes)

export default NotesContainer
